import axios from 'axios';
import * as actionTypes from '../ActionTypes'
import {baseUrl} from '../../Constants/Constants';
import {errorHandler} from "../../Constants/Constants";
import { notification} from "antd";


export const entriesListStart = () => {
    return {
        type: actionTypes.ENTRIES_START,
    };
};

export const entriesListSuccess = (entries) => {
    return {
        type: actionTypes.ENTRIES_SUCCESS,
        entries,
    };
};

export const entriesListFail = (error) => {
    return {
        type: actionTypes.ENTRIES_FAIL,
        error,
    };
};

export const entrieslList = (price, area, time) => {
    const token = localStorage.getItem('token')
    const data = {
        'locationAvailable': true,
    }
    if (price !== 0 & price !== undefined) {
        data.priceGte = price[0]
        data.priceLte = price[1]
    } else {
        data.priceGte = 20000
        data.priceLte = 70000
    }
    if (area !== 0 && area !== undefined) {
        data.areaLte = area[1]
        data.areaGte = area[0]
    } else {
        data.areaLte = 160
        data.areaGte = 20
    }
    let date = new Date();
    const week = date.setDate(date.getDate()-7);

    if (time !== 0 & time !== undefined) {
        data.minTimestamp = time;
    } else {
        data.minTimestamp = week;
    }

    return (dispatch) => {
        dispatch(entriesListStart());

        const url = `${baseUrl}v1/shtepiaplus/entries`;
        axios({
            method: 'get',
            url,
            params: data,
            headers: {Authorization: token, app_version: 1, client_app_type: 'web'}
        }).then((response) => {
            dispatch(entriesListSuccess(response.data.data));
        })
            .catch((error) => {
                if(error.message === 'network error') {
                  notification.error({message: 'network error'})
                } else if (error.response !== undefined){
                    errorHandler(error);
                }
                dispatch(entriesListFail(error));

            });
    };
};
